import { render, staticRenderFns } from "./wpay.vue?vue&type=template&id=09127ab0&"
import script from "./wpay.vue?vue&type=script&lang=js&"
export * from "./wpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports